import { render, staticRenderFns } from "./FacturaList.vue?vue&type=template&id=fa485180"
import script from "./FacturaList.vue?vue&type=script&lang=js"
export * from "./FacturaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports